const state = {
  openId: window.localStorage.getItem("openId"),
  personId:window.localStorage.getItem("personId"),
  // userInfo: JSON.parse(window.localStorage.getItem("userInfo") || '{}')
};
const mutations = {
  setOpenId(state, val) {
    state.openId = val;
  },
  setPersonId(state, val) {
    state.personId = val;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
